/**
 * This file should be used for any generic helpers on the window object.
 */

/**
 * Assigns a new window location and never resolves
 * This is useful to prevent forms from re-enabling momentarily before a transition
 * @param location
 * @return {Promise<void>}
 */
export function blockingLocationAssign(location) {
  window.location.assign(location);
  return new Promise(() => { });
}

/**
 * Opens a popup window with the various requirements
 *
 * @param {String} url        Url of the new window
 * @param {String} title      Name of the window
 * @param {String} popWidth   Width of the window
 * @param {String} popHeight  Height of the window
 */
export function openPopupWindow(url, title, popWidth, popHeight) {
  let dualScreenLeft = window.screenLeft !== undefined ?
      window.screenLeft :
      window.screenX,
    dualScreenTop = window.screenTop !== undefined ?
      window.screenTop :
      window.screenY,
    width = window.innerWidth ?
      window.innerWidth :
      document.documentElement.clientWidth ?
        document.documentElement.clientWidth :
        screen.width,
    height = window.innerHeight ?
      window.innerHeight :
      document.documentElement.clientHeight ?
        document.documentElement.clientHeight :
        screen.height,
    systemZoom = width / window.screen.availWidth,
    left = (width - popWidth) / 2 / systemZoom + dualScreenLeft,
    top = (height - popHeight) / 2 / systemZoom + dualScreenTop,
    newWindow = window.open(
      url,
      title,
      `scrollbars=yes,width=${popWidth / systemZoom},height=${popHeight / systemZoom},top=${top * systemZoom},left=${left}`);

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus();
  }
}

/**
 * Get the Full Story session url if it exists.
 *
 * @return {string}
 */
export function getFullStorySessionUrl() {
  let fullStorySessionUrl = '';
  if (window.FS && window.FS.getCurrentSessionURL) {
    fullStorySessionUrl = window.FS.getCurrentSessionURL();
  }

  return fullStorySessionUrl;
}
